<template>
  <div>
    <b-row>
      <b-col class="mt-2 mb-2" cols="12">
        <div class="has-search">
          <d-select-input-search
            :options="clubs"
            :place-holder="$t('admin.duplicate.search-club-model')"
            class-name="bg-white mt-2 mb-3 w-75"
            icon="fa fa-search"
            @on:keydown="filterClubs($event)"
            @on:selected="onSelect"
          />
        </div>
      </b-col>
      <b-col cols="8" class="simple-label-avenir">
        <h5
          :class="checkedCategory ? 'text-success' : 'text-danger'"
        >
          {{ selectedCategory }}
        </h5>
      </b-col>
      <b-col align="right">
        <div class="has-search">
          <span class="fa fa-search form-control-feedback fa-1-5x"></span>
          <input
            type="text"
            class="form-control"
            v-model="filter"
            :placeholder="$t('components.doinsport.table.search')"
          >
        </div>
      </b-col>
    </b-row>
    <d-table
      identifier="category-shop"
      :tablefields="fields"
      :items="items"
      :per-page="itemsPerPage"
      :totalRows="totalRows"
      :is-busy="isBusy"
      :per-page-enabled="true"
      :tr-cursor-pointer="false"
      @per-page:update="onPerPageUpdate"
      @on:data-table-btn:radio="onDataTableCheck"
      @current-page:update="onPageUpdate"
    >
    </d-table>
  </div>
</template>
<script>
import {getAllCategoriesProducts, getAllProducts} from "@api/services/products/products.api";
import {isNotUndefinedAndNotNull} from "@/utils/classes";
import {getClubs} from "@api/services/club/club.api";

export default {
  data: () => ({
    items: [],
    clubs: [],
    filterClub: '',
    filter: '',
    selectAll: false,
    selectedClubId: '',
    isBusy: false,
    checkedCategory: null,
    timer: null,
    itemsPerPage: 10,
    totalRows: 1,
    currentPage: 1,
  }),
  props: {
    reload: {
      type: Boolean,
      default: false
    },
    filter: {
      type: String,
      default: ''
    },
    isArchived: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    reload: function () {
      this.loadShopProducts(this.itemsPerPage, this.currentPage, this.filter);
    },
    filter: function () {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        this.loadShopProducts(this.itemsPerPage, this.currentPage, this.filter + ' ' + this.filterClub);
      }, 400);
    },
    filterClub: function () {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        this.loadShopProducts(this.itemsPerPage, this.currentPage, this.filter + ' ' + this.filterClub);
      }, 400);
    }
  },
  computed: {
    getClubList() {
      return this.$store.getters['club/getClubList'];
    },
    selectedCategory() {
      return this.checkedCategory ? this.$t('admin.duplicate.shop-category.selected-shop-product', {
        cat: this.checkedCategory.name,
        club: 'YouJump',
        name: this.checkedCategory.club.name
      }) : this.$t('admin.duplicate.shop-category.select-shop-product');
    },
    alignCellsToLeft() {
      return this.$store.getters['layout/getInnerWidth'] >= 991 ? 'text-center' : 'text-left';
    },
    clubs() {
      return this.$store.getters['club/getClubs']
    },
    fields() {
      return [
        {
          key: "name",
          label: this.$t('admin.duplicate.shop-category.title'),
          sortable: true,
        },
        {
          key: "description",
          label: this.$t('admin.duplicate.shop-category.description'),
          sortable: true
        },
        {
          key: "club.name",
          label: this.$t('admin.duplicate.shop-category.club'),
        },
        {
          key: "actions",
          label: this.$t("general.actions.actions"),
        },
      ];
    },
  },
  methods: {
    onSelect($event) {
      this.$store.commit('duplicate/setSelectedCategoryModel', null);

      if ($event === null) {
        this.selectedClubId = '';
        this.loadShopProducts(this.itemsPerPage, this.currentPage, this.filter);
      } else {
        this.selectedClubId = $event.item.id;
        this.loadShopProducts(this.itemsPerPage, this.currentPage, this.filter);
      }
    },
    onDataTableCheck($event) {
      this.checkedCategory = $event;

      this.$store.commit('duplicate/setSelectedCategoryModel', this.checkedCategory);
      setTimeout(() => {
        document.getElementById('categoryListDuplicateId').scrollIntoView({behavior: 'smooth', block: 'start'});
      }, 300)
      ;
    },
    onPageUpdate(page) {
      this.loadShopProducts(this.itemsPerPage, page, this.filter);
    },
    onPerPageUpdate(itemsPerPage) {
      this.itemsPerPage = itemsPerPage;
      this.currentPage = 1;
      this.loadShopProducts(itemsPerPage, this.currentPage, this.filter);
    },
    loadShopProducts(itemsPerPage, currentPage, filter) {
      this.items = [];
      this.isBusy = true;
      const filterTag = 'asc';

      getAllCategoriesProducts(itemsPerPage, currentPage, filter, filterTag,null, this.selectedClubId)
        .then((response) => {
          this.totalRows = response.data['hydra:totalItems'];

          for (const item of response.data['hydra:member']) {
            item.actions = ['radio'];
            item.checked = true;

            this.items.push(item);
          }
        })
        .finally(() => {
          this.isBusy = false;
        })
      ;
    },
    filterClubs(filter = '') {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        this.loadClubs(filter);
      }, 400);
    },
    loadClubs(filter = '') {
      this.clubs = [];

      getClubs(1, 500, filter)
        .then((response) => {

          for (const club of response.data['hydra:member']) {
            this.clubs.push({
              label: club.name,
              id: club.id,
              item: club,
              iri: club['@id'],
            });
          }
        })
      ;
    },
  },
  created() {
    this.clubs = this.getClubList;
    this.loadShopProducts(this.itemsPerPage, this.currentPage, this.filter);
  }
}
</script>
<style scoped lang="scss">
@import "@lazy/_b-card.scss";

/deep/ .card .card-body {
  padding-left: 25px;
  padding-right: 25px;
}

/deep/ .page-item.active .page-link {
  z-index: 0;
  color: #fff;
  background-color: #092772;
  border-color: #092772;
}
</style>
